import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=48934e1c&scoped=true&"
import script from "./SimpleModal.vue?vue&type=script&lang=js&"
export * from "./SimpleModal.vue?vue&type=script&lang=js&"
import style0 from "./SimpleModal.vue?vue&type=style&index=0&id=48934e1c&prod&scoped=true&lang=css&"
import style1 from "./SimpleModal.vue?vue&type=style&index=1&id=48934e1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48934e1c",
  null
  
)

export default component.exports